import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { getFirebaseApp } from './firebaseConfig';

const storage = getStorage(getFirebaseApp());

export const uploadToolImage = async (file, userId, toolName, idx) => {
  const ext = file.name.split('.').pop();
  const path = `tools/${userId}/${toolName}_${Date.now()}_${idx}.${ext}`;
  const storageRef = ref(storage, path);
  await uploadBytes(storageRef, file);
  return await getDownloadURL(storageRef);
};
